// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f_flex_base {
  display: flex;
}

.f_flex_base:empty {
  gap: initial;
}

.f_flex_single_value_flex_basis {
  flex-basis: var(--f_flex_flex_basis);
}

.f_flex_single_value_flex_grow {
  flex-grow: var(--f_flex_flex_grow);
}

.f_flex_single_value_flex_shrink {
  flex-shrink: var(--f_flex_flex_shrink);
}

.f_flex_variable_flex {
  flex: var(--f_flex_flex_mobile);
}

@media screen and (min-width: 768px) {
  .f_flex_variable_flex {
    flex: var(--f_flex_flex_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_flex_variable_flex {
    flex: var(--f_flex_flex_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_flex_variable_flex {
    flex: var(--f_flex_flex_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_flex_variable_flex {
    flex: var(--f_flex_flex_xxlarge);
  }
}

.f_flex_single_value_align {
  align-items: var(--f_flex_align_mobile);
}

.f_flex_variable_align {
  align-items: var(--f_flex_align_mobile);
}

@media screen and (min-width: 768px) {
  .f_flex_variable_align {
    align-items: var(--f_flex_align_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_flex_variable_align {
    align-items: var(--f_flex_align_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_flex_variable_align {
    align-items: var(--f_flex_align_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_flex_variable_align {
    align-items: var(--f_flex_align_xxlarge);
  }
}

.f_flex_single_value_justify {
  justify-content: var(--f_flex_justify_mobile);
}

.f_flex_variable_justify {
  justify-content: var(--f_flex_justify_mobile);
}

@media screen and (min-width: 768px) {
  .f_flex_variable_justify {
    justify-content: var(--f_flex_justify_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_flex_variable_justify {
    justify-content: var(--f_flex_justify_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_flex_variable_justify {
    justify-content: var(--f_flex_justify_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_flex_variable_justify {
    justify-content: var(--f_flex_justify_xxlarge);
  }
}

.f_flex_single_value_direction {
  flex-direction: var(--f_flex_direction_mobile);
}

.f_flex_variable_direction {
  flex-direction: var(--f_flex_direction_mobile);
}

@media screen and (min-width: 768px) {
  .f_flex_variable_direction {
    flex-direction: var(--f_flex_direction_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_flex_variable_direction {
    flex-direction: var(--f_flex_direction_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_flex_variable_direction {
    flex-direction: var(--f_flex_direction_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_flex_variable_direction {
    flex-direction: var(--f_flex_direction_xxlarge);
  }
}

.f_flex_single_value_gap {
  gap: var(--f_flex_gap_mobile);
}

.f_flex_variable_gap {
  gap: var(--f_flex_gap_mobile);
}

@media screen and (min-width: 768px) {
  .f_flex_variable_gap {
    gap: var(--f_flex_gap_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_flex_variable_gap {
    gap: var(--f_flex_gap_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_flex_variable_gap {
    gap: var(--f_flex_gap_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_flex_variable_gap {
    gap: var(--f_flex_gap_xxlarge);
  }
}
`, "",{"version":3,"sources":["webpack://./../../core/web/src/slate/Layout/native-styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,YAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".f_flex_base {\n  display: flex;\n}\n\n.f_flex_base:empty {\n  gap: unset;\n}\n\n.f_flex_single_value_flex_basis {\n  flex-basis: var(--f_flex_flex_basis);\n}\n\n.f_flex_single_value_flex_grow {\n  flex-grow: var(--f_flex_flex_grow);\n}\n\n.f_flex_single_value_flex_shrink {\n  flex-shrink: var(--f_flex_flex_shrink);\n}\n\n.f_flex_variable_flex {\n  flex: var(--f_flex_flex_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_flex_variable_flex {\n    flex: var(--f_flex_flex_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_flex_variable_flex {\n    flex: var(--f_flex_flex_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_flex_variable_flex {\n    flex: var(--f_flex_flex_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_flex_variable_flex {\n    flex: var(--f_flex_flex_xxlarge);\n  }\n}\n\n.f_flex_single_value_align {\n  align-items: var(--f_flex_align_mobile);\n}\n\n.f_flex_variable_align {\n  align-items: var(--f_flex_align_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_flex_variable_align {\n    align-items: var(--f_flex_align_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_flex_variable_align {\n    align-items: var(--f_flex_align_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_flex_variable_align {\n    align-items: var(--f_flex_align_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_flex_variable_align {\n    align-items: var(--f_flex_align_xxlarge);\n  }\n}\n\n.f_flex_single_value_justify {\n  justify-content: var(--f_flex_justify_mobile);\n}\n\n.f_flex_variable_justify {\n  justify-content: var(--f_flex_justify_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_flex_variable_justify {\n    justify-content: var(--f_flex_justify_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_flex_variable_justify {\n    justify-content: var(--f_flex_justify_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_flex_variable_justify {\n    justify-content: var(--f_flex_justify_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_flex_variable_justify {\n    justify-content: var(--f_flex_justify_xxlarge);\n  }\n}\n\n.f_flex_single_value_direction {\n  flex-direction: var(--f_flex_direction_mobile);\n}\n\n.f_flex_variable_direction {\n  flex-direction: var(--f_flex_direction_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_flex_variable_direction {\n    flex-direction: var(--f_flex_direction_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_flex_variable_direction {\n    flex-direction: var(--f_flex_direction_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_flex_variable_direction {\n    flex-direction: var(--f_flex_direction_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_flex_variable_direction {\n    flex-direction: var(--f_flex_direction_xxlarge);\n  }\n}\n\n.f_flex_single_value_gap {\n  gap: var(--f_flex_gap_mobile);\n}\n\n.f_flex_variable_gap {\n  gap: var(--f_flex_gap_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_flex_variable_gap {\n    gap: var(--f_flex_gap_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_flex_variable_gap {\n    gap: var(--f_flex_gap_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_flex_variable_gap {\n    gap: var(--f_flex_gap_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_flex_variable_gap {\n    gap: var(--f_flex_gap_xxlarge);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
